var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.unit),expression:"unit"}],staticClass:"amount-unit-tip"},[_vm._v(_vm._s(_vm.unit))])
}
var staticRenderFns = []

export { render, staticRenderFns }